module.exports = __webpack_public_path__ + "static/media/road.85f3387f.svg";